import Butter from "buttercms";

const butter = Butter("db35569d3bb3739cf02d32a74a1b5f6dc6243d57");

export default butter;
